import { ResponseType } from '../../enums/response-type.enum';
import { enumToList } from '..';
import { Pipe, PipeTransform } from '@angular/core';
import { IdName } from 'src/app/shared/models/id-name.model';

@Pipe({
  name: 'responseType',
  standalone: false
})
export class ResponseTypePipe implements PipeTransform {
  public transform(value: ResponseType): string {
    return getResponseType(value);
  }
}

export function getResponseType(value: ResponseType): string {
  switch (value) {
    case ResponseType.Create:
      return 'Create';
    case ResponseType.Submit:
      return 'Submit';
    case ResponseType.Accept:
      return 'Accept';
    case ResponseType.AcceptReject:
      return 'Accept & Reject';
    case ResponseType.Editor:
      return 'Editor & Owner';
    default:
      throw new Error(`Unsupported value for ResponseType: ${value}.`);
  }
}

const RESPONSE_TYPE_SELECTORS = Object.freeze([ResponseType.Accept, ResponseType.AcceptReject, ResponseType.Editor]);

export function getResponseTypeList(): IdName[] {
  const list = enumToList(ResponseType, getResponseType);

  return RESPONSE_TYPE_SELECTORS.map((x) => list.find((y) => y.id === x));
}
